import httpService from "./httpService";
import constants from "../constants";

export default {
  nextSteps(flowId, stepId, stepType) {
    return httpService.get("/nextStepInfoView/nextSteps", {
      params: {
        flowId: flowId,
        stepId: stepId,
        stepType: stepType
      }
    });
  },

  getDepartmentsAndUsersInNextStep(flowId, stepId, isGetUserInStepDonVi) {
    return httpService.get("/nextStepInfoView/getDepartmentsAndUsersInNextStep", {
      params: {
        flowId: flowId,
        stepId: stepId,
        isGetUserInStepDonVi: isGetUserInStepDonVi
      }
    });
  },

  findAllForBanHanh(docId) {
    let params = {docId: docId};
    return httpService.get("/nextStepInfoView/findAllForBanHanh", {
      params: params
    });
  },

  isMatchingWithUserDeptRole(userDeptRole, nextStepInfoView) {
    return (
      nextStepInfoView.stepType === constants.STEP.STEP_TYPE.CANHAN &&
      (!nextStepInfoView.deptId || nextStepInfoView.deptId === userDeptRole.deptId) &&
      (!nextStepInfoView.roleId || nextStepInfoView.roleId === userDeptRole.roleId) &&
      (!nextStepInfoView.userId || nextStepInfoView.userId === userDeptRole.userId)
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/nextStepInfoViewService.js